<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    title="Merge Actor"
    submit-name="Merge"
    :submit-disabled="!actorToMerge"
    full-height
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <p class="text-gray-700 mb-4">
      Merging an Actor A into another Actor B will move all of its children and
      content (Topics and Sources) into the Actor B, then it will remove the
      selected Actor A from the tree.
    </p>
    <img src="./images/examples/merge.jpg" class="mx-auto mb-6 border" />
    <template v-if="selectedActor">
      <p class="mb-2 text-gray-700">
        Select the Actor where
        <span :class="'text-' + selectedActor.color">{{
          selectedActor.name
        }}</span>
        will be merged:
      </p>
      <lm-actor-select
        v-if="selectedActor"
        ref="actorSelect"
        :selected-actor="selectedActor"
        disable-children
        check-rights
        show-placeholder
        @on-select="actorToMerge = getActorByID($event)"
      />
    </template>
    <template v-if="actorToMerge">
      <p class="mt-8 mb-2 text-gray-700">
        Actor
        <span :class="'text-' + selectedActor.color">{{
          selectedActor.name
        }}</span>
        will be deleted and all their content moved into
        <span :class="'text-' + originActorColor">{{ originActorName }}</span
        >.
        <br />
        Are you sure you want to merge these actors?
      </p>
      <lm-checkbox v-model="checked" label="Merge these actors" />
      <transition name="fade">
        <span v-show="checkError" class="block mt-2 text-xs text-error">{{
          checkError
        }}</span>
      </transition>
      <div class="flex items-center mt-5 px-2 py-4 border">
        <lm-icon icon="warning" class="text-error mr-3" />
        <p class="m-0 text-gray-700">
          Please note: this process cannot be undone.
        </p>
      </div>
    </template>
  </form-modal>
</template>

<script>
import LmActorSelect from '@/components/form/LmActorSelect'
import LmCheckbox from '@/components/form/LmCheckbox'
import LmIcon from '@/components/ui/LmIcon'
import EventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'
import {AlertMessages, Events, Modal} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'
import FormHelper from '@/components/form/formHelper'

export default {
  name: Modal.MERGE_ACTOR,
  components: {
    LmActorSelect,
    LmIcon,
    LmCheckbox,
    FormModal
  },
  data() {
    return {
      Events,
      modalName: Modal.MERGE_ACTOR,
      modalRef: null,
      inputs: null,
      checked: false,
      checkError: '',
      actorToMerge: null
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'currentLandscape', 'getActorByID']),
    originActorName() {
      return this.actorToMerge ? this.actorToMerge.name : null
    },
    originActorColor() {
      return this.actorToMerge ? this.actorToMerge.color : null
    }
  },
  watch: {
    checked(b) {
      if (b) this.checkError = ''
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.actorSelect]
  },
  methods: {
    submit() {
      if (this.checked && FormHelper.validate(this.inputs)) {
        this.$store
          .dispatch('mergeActor', {origin: this.$refs.actorSelect.data})
          .then(actorPathArr => {
            this.actorPathArr = actorPathArr
            this.modalRef.submitSuccess()
          })
          .catch(error => this.modalRef.submitFails(error))
      } else {
        if (!this.checked) {
          this.checkError = `* Check this if you really want to perform this action.`
        }
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, AlertMessages.ACTOR_MERGED)
        this.$router.push({
          name: 'info',
          params: {actor: this.actorPathArr}
        })
      }
    }
  }
}
</script>
